import { useEffect, useState } from 'react';

export const useDebounce = (
  value: string,
  delay: number,
  onDebounceValue?: (val: string) => void,
) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
        if (onDebounceValue) {
          onDebounceValue(value);
        }
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, delay], // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};
